"use client";
import { useEffect } from "react";

export const Alert = ({ message, type, isVisible, onDismiss }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onDismiss(); // Llama a onDismiss en vez de cambiar la visibilidad
    }, 1500); // Después de 1.5 segundos, invoca onDismiss

    return () => clearTimeout(timer); // Limpia el temporizador si el componente se desmonta
  }, [onDismiss]);

  let color;
  switch (type) {
    case "error":
      color = "bg-red-500";
      break;
    case "success":
      color = "bg-green-500";
      break;
    default:
      color = "bg-gray-200";
  }

  return (
    <div
      className={`absolute bottom-10 right-10 p-4 rounded-lg ${color} text-white ${
        isVisible ? "opacity-100" : "animate-slide-out-left"
      }`}
    >
      <p>
        {message.split("\n").map((line, index) => (
          <span key={index}>
            {line}
            <br />
          </span>
        ))}
      </p>
    </div>
  );
};
